/**
 * FreezeIcon — sanitized from `assets/newSvg/freeze.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function FreezeIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M9,3 C9.55228,3 10,3.44772 10,4 L10,4 L10,20 C10,20.5523 9.55228,21 9,21 L9,21 L7,21 C6.44772,21 6,20.5523 6,20 L6,20 L6,4 C6,3.44772 6.44772,3 7,3 L7,3 Z M17,3 C17.5523,3 18,3.44772 18,4 L18,4 L18,20 C18,20.5523 17.5523,21 17,21 L17,21 L15,21 C14.4477,21 14,20.5523 14,20 L14,20 L14,4 C14,3.44772 14.4477,3 15,3 L15,3 Z"
        fill={color}
      />
    </Svg>
  );
}

export default FreezeIcon;
